export default __webpack_public_path__ + "static/media/commonroad_rl.f2a118bb.png";